import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { EMBER_ROUTE_NAMES } from 'sh-www/constants/routes';

class RequiresFunnelRoute extends Route {
  @service router;
  @service session;

  redirect() {
    const { isAuthenticated, currentUser } = this.session;

    const redirectPath = (() => {
      if (!isAuthenticated || !currentUser) {
        return EMBER_ROUTE_NAMES.SIGNIN;
      } else if (!currentUser.funnel) {
        return null;
      } else if (currentUser.isBuyer) {
        return this.routeBuyer(currentUser);
      } else if (currentUser.isSeller) {
        return this.routeSeller(currentUser);
      } else {
        return null;
      }
    })();

    if (redirectPath) {
      this.router.transitionTo(redirectPath);
    }
  }

  routeSeller(currentUser) {
    if (!currentUser.signupStep || !currentUser.hasCredentials) {
      return EMBER_ROUTE_NAMES.SIGNUP__INDEX;
    } else if (currentUser.signupStep !== 'done') {
      return EMBER_ROUTE_NAMES.SIGNUP__STEP;
    } else {
      return null;
    }
  }

  routeBuyer(currentUser) {
    if (currentUser.company && !currentUser.hasCredentials) {
      return EMBER_ROUTE_NAMES.JOIN_COMPANY;
    } else if (!currentUser.hasCredentials) {
      return EMBER_ROUTE_NAMES.BRAND__SIGNUP;
    } else {
      return EMBER_ROUTE_NAMES.BRAND__SIGNUP__STEP;
    }
  }
}

export default RequiresFunnelRoute;
